// A short two-note chime drawn with Web Audio, so no sound file ships with the app.
const NOTES = [
  { hz: 880, at: 0 },
  { hz: 1320, at: 0.09 },
]
const VOLUME = 0.3
const FADE_S = 0.35

let context: AudioContext | null = null

const audio = (): AudioContext | null => {
  if (typeof window === 'undefined' || !('AudioContext' in window)) return null
  context ??= new AudioContext()
  return context
}

export const playDing = (): void => {
  try {
    const ctx = audio()
    if (!ctx) return
    // Browsers keep audio suspended until the page has had a click; until then the ding is skipped.
    if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined)
    const now = ctx.currentTime
    NOTES.forEach(({ hz, at }) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'sine'
      osc.frequency.value = hz
      gain.gain.setValueAtTime(0.0001, now + at)
      gain.gain.exponentialRampToValueAtTime(VOLUME, now + at + 0.01)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + FADE_S)
      osc.connect(gain).connect(ctx.destination)
      osc.start(now + at)
      osc.stop(now + at + FADE_S + 0.05)
    })
  } catch {
    // A missing or blocked audio device only costs the ding.
  }
}
